import React, { useEffect, useState } from 'react';

const useForceRefetch = () => {
  const [shouldRefetch, setShouldRefetch] = useState<string | null>(null);

  useEffect(() => {}, [shouldRefetch]);

  const forceRefetch = () => {
    setShouldRefetch(new Date().toISOString());
  };

  return { shouldRefetch, forceRefetch };
};

export default useForceRefetch;
